import { render } from "./InstallmentsInfoBox.vue?vue&type=template&id=6a04bf28"
import script from "./InstallmentsInfoBox.vue?vue&type=script&lang=js"
export * from "./InstallmentsInfoBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__